import bilAPI from "./api";

// A question's versions (ТЗ 3.2): a snapshot of its content after each save that changes it. Read by whoever reads
// the question. Not versioned: its passage link, the admin's edits, its draft and its status (that one is in the
// status history). A question from before versions has none until it first changes; then its old content becomes
// version 1, reason "baseline", with no author.

// The versions, newest first, without their content:
// [{number, reason: "create" | "import" | "edit" | "submit" | "baseline", status_code,
//   author: {uuid, username, first_name, last_name} | null, created}]
export const getQuestionVersions = (uuid, { signal } = {}) =>
  bilAPI.get(`/questions/questions/${uuid}/versions/`, { signal }).then((res) => res.data);

// One version with its content: the row above plus
// data: {name, body, difficulty, subtopic_id, purpose_id, objective_id, answer_keys: [{option, body, is_correct}],
//        labels: {subtopic, topic, purpose, objective}}. 404 when the question has no such version.
export const getQuestionVersion = (uuid, number, { signal } = {}) =>
  bilAPI.get(`/questions/questions/${uuid}/versions/${number}/`, { signal }).then((res) => res.data);
